import axios from 'axios';

import { getApiEndPoint } from '../helpers/apibase';
import { mapServerError } from './utils/serverErrorMapper';

type AuthorizedResource = {
  decision: string;
  allowed: boolean;
  policyIds: string[];
  resource: {
    type: 'Org' | 'Brand' | 'Property' | 'SalesChannel';
    id: string;
  };
};

export type GetAuthorizedOrgsResponse = {
  allowedResources: AuthorizedResource[];
  deniedResources: AuthorizedResource[];
};

export type GetAuthorizedOrgsPrincipal = {
  type: 'User';
  id: string;
  email?: string;
};

type GetAuthorizedOrgsRequest = {
  action: string;
  principal: GetAuthorizedOrgsPrincipal;
};

const authorizedOrgsApi = axios.create({
  baseURL: getApiEndPoint(),
  withCredentials: true,
});

export async function getAuthorizedOrgs(
  principal: GetAuthorizedOrgsPrincipal,
  action = 'ViewOrg'
): Promise<GetAuthorizedOrgsResponse> {
  const body: GetAuthorizedOrgsRequest = { action, principal };

  try {
    const response = await authorizedOrgsApi.post<GetAuthorizedOrgsResponse>(
      '/auth/getAuthorizedOrgs',
      body
    );
    return response.data;
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

const authorizedOrgsService = {
  getAuthorizedOrgs,
};

export default authorizedOrgsService;
